import React, { useEffect, useRef, useState } from 'react';
import { Container, Grid, Box, Card, Typography, useMediaQuery, IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import _ from 'lodash';
import SwiperCore, { Pagination, Navigation, EffectCoverflow, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import TopNavHelpButton from '../../components/TopNavHelpButton/TopNavHelpButton';
import { connect } from 'react-redux';
import { tracking } from '../../utils/tracking';
import { renderHeaderButton } from '../../store/headerButtonControl/duck';
import {
  getIsChubbUser,
  hasCampaignCode,
  shouldEnableAiCoach,
  shouldEnableChatGPT,
  shouldEnableMedicalReserve,
  shouldShowAdviserFirstGuideline
} from '../../utils/user';
import AdviserFirstGuidelineTooltip from '../../components/guidelines/AdviserFirstGuidelineTooltip/AdviserFirstGuidelineTooltip';
import { endGuideline, runGuideline } from '../../store/guideline/duck';
import { getNewReferralCount } from '../../store/referral/duck';
import { ADVISER_HOME_PAGE_BANNERS } from '../../constants/adviser-home-page';
import AdviserLoginLogic from '../../components/LoginLogic/AdviserLoginLogic';
import AppContentContainer from '../../components/AppContentContainer/AppContentContainer';
import BusinessToolsSection from './BusinessToolsSection/BusinessToolsSection';
import MoreToolsSection from './MoreToolsSection/MoreToolsSection';
import DashboardSection from './DashboardSection/DashboardSection';
import ShortcutsSection from './ShortcutsSection/ShortcutsSection';
import LinkerNfcCardInstruction from './LinkerNfcCardInstruction';
import { toggleControl } from '../../store/control/duck';
import { TopNavigationPortal } from '../../components/topNavigation';
import TeamBlastPopUp from './TeamBlastPopUp';
import { markNotificationAsRead } from '../../store/notificationCenter/duck';
import { updateFirstGuidelineState } from '../../store/user/duck';
import ChatGPTFab from './ChatGPTFab/ChatGPTFab';
import SupportFab from './SupportFab/SupportFab';
import { UserSubscription } from '../../utils/user-subscription';
import SubscriptionDialog from '../Subscription/SubscriptionDialog/SubscriptionDialog';
import LinkerAdviserHeader from '../../components/LinkerAdviserHeader/LinkerAdviserHeader';
import NewDashboardCardWithIconLarge from '../../components/NewDashboardCard/NewDashboardCardWithIconLarge';
import NewDashboardCardWithIconSmall from '../../components/NewDashboardCard/NewDashboardCardWithIconSmall';
import VersionToggleButton from '../../components/NewDashboardVersionToggleButton/NewDashboardVersionToggleButton';
import SupportDialog from '../../components/SupportDialog/SupportDialog';
import SupportBottomSheet from '../../components/SupportBottomSheet/SupportBottomSheet';
import ChatBotDialog from '../../components/ChatBot/ChatBotDialog';
import ContactUsDialog from '../../components/ContactUsDialog/ContactUsDialog';
import { toggleDialog } from '../../store/control/duck';
import { shouldShowGPTDisclaimer } from '../../utils/openai';
import { isNavAside } from '../../utils/device';
import { FINANCIAL_CHARTS_SAVE_EARLY_ITEM } from '../../constants/financial-charts';
import { toast } from 'react-toastify';
import IconToast from '../../components/NewToast';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/navigation/navigation.scss';
import './AdviserHomePage.scss';
import NativeOrWeb from '../../utils/native';
import getSourcesCheck from '../../utils/missionAndReward/getSourcesCheck';
import getFeelingTagCheck from '../../utils/missionAndReward/getFeelingTagCheck';
import { trackDirect } from '../../store/analytics/api';
import TravelKitLinkConstructor from '../ExportOptions/TravelKitLinkConstructor/TravelKitLinkConstructor';

SwiperCore.use([Pagination, Navigation, EffectCoverflow, Autoplay]);

// Number of `new-dashboard-welcome-message-N` keys in the locale files
const WELCOME_MESSAGE_COUNT = 40;

const AdviserHomePage = props => {
  const {
    intl,
    history,
    location,
    userDetails,
    userSubscription,
    stripePromise,
    teamCampaignCodes,
    renderHeaderButton,
    runGuideline,
    getNewReferralCount,
    toggleControl,
    endGuideline,
    hasTeamBlast,
    teamBlastPop,
    markNotificationAsRead,
    firstGuidelineRan,
    updateFirstGuidelineState,
    toggleDialog
  } = props;

  const [version, setVersion] = useState('lite');
  const [sosLinkDialogOpen, setSosLinkDialogOpen] = useState(false);
  const [showTeamBlast, setShowTeamBlast] = useState(false);
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
  const [linkNfcCardDialogOpen, setLinkNfcCardDialogOpen] = useState(false);
  const [supportDialogOpen, setSupportDialogOpen] = useState(false);
  const [supportBottomSheetOpen, setSupportBottomSheetOpen] = useState(false);
  const [welcomeMessageId, setWelcomeMessageId] = useState(Math.floor(Math.random() * WELCOME_MESSAGE_COUNT + 1));
  const [refreshClickCount, setRefreshClickCount] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [contactUsDialogOpen, setContactUsDialogOpen] = useState(false);
  const isXsScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const topNavHelpButtonRef = useRef(null);
  const isSideNav = isNavAside();

  const userSubscriptionO = new UserSubscription(userSubscription);
  const isLinkerUser = userSubscriptionO.containVaildLinkerSubscription();
  const currentCoreSubscription = userSubscriptionO.getCurrentCoreSubscription();
  const isChubbUser = getIsChubbUser();
  const showAiCoach = shouldEnableAiCoach({
    user: userDetails,
    teamCampaignCodes: teamCampaignCodes
  });
  const showChatGPT = shouldEnableChatGPT({
    user: userDetails,
    teamCampaignCodes: teamCampaignCodes,
    userSubscription: userSubscription
  });
  const showMedicalReserve = shouldEnableMedicalReserve({
    user: userDetails,
    teamCampaignCodes: teamCampaignCodes,
    userSubscription: userSubscription
  });

  const openSubscriptionDialog = () => {
    setSubscriptionDialogOpen(true);
  };

  const getTopNavHelpButtonInstance = () => {
    const topNavHelpButton = _.get(topNavHelpButtonRef, 'current');
    return topNavHelpButton ? topNavHelpButton.getWrappedInstance() : undefined;
  };

  const onCloseAllDialogs = () => {
    const runAdviserFirstGuideline = () => {
      if (shouldShowAdviserFirstGuideline(userDetails)) {
        setTimeout(() => {
          runGuideline('adviserWelcome', {
            parameters: {
              intl: intl,
              onFinish: () => {
                const topNavHelpButtonInstance = getTopNavHelpButtonInstance();
                if (topNavHelpButtonInstance) {
                  topNavHelpButtonInstance.open();
                }
              }
            },
            tooltipComponent: AdviserFirstGuidelineTooltip
          });
        }, 400);
      }
    };

    if (!firstGuidelineRan && shouldShowAdviserFirstGuideline(userDetails)) {
      updateFirstGuidelineState(true);
      runAdviserFirstGuideline();
    } else {
      toggleControl('addToHomeSnackbar', true);
    }
  };

  // The travel kit constructor, opened from the pro banner and the lite card.
  // Gated on Pro exactly like the Door Opener card that opens the same dialog.
  const openTravelKit = source => {
    if (!userSubscriptionO.containVaildProSubscription()) {
      openSubscriptionDialog();
      return;
    }
    tracking(`TravelKit Link Constructor Accessed - ${source}`);
    setSosLinkDialogOpen(true);
  };

  const onClickBanner0 = () => {
    tracking('Click on banners - Homepage');
    openTravelKit('Homepage Banner');
  };

  const onClickBanner1 = () => {
    tracking('Click on banners - Homepage');
    history.push('/hot_topic');
  };

  const onClickBanner2 = () => {
    tracking('Click on banners - Homepage');
    const helpCenterPath = NativeOrWeb.isIOSPlatform() ? '/new_help_center_public' : '/new_help_center';
    history.push(helpCenterPath);
  };

  const markAsRead = data => {
    if (data.receipients.ids.state === 'new') {
      markNotificationAsRead(data._id);
    }
  };

  const openChatBot = () => {
    if (shouldShowGPTDisclaimer()) {
      toggleDialog('chatGPTDisclaimer', { action: 'openChatBot' });
    } else {
      toggleDialog('chatBot', true);
    }
  };

  const openFinancialConcept = () => {
    let defaultItem = { ...FINANCIAL_CHARTS_SAVE_EARLY_ITEM };
    toggleDialog('financialCharts', { defaultItem });
  };

  const handleRefreshWelcomeMessage = () => {
    if (refreshClickCount >= 3) return;

    setIsRefreshing(true);
    setRefreshClickCount(prev => prev + 1);

    // 生成新的隨機訊息ID，確保與當前不同
    let newMessageId;
    do {
      newMessageId = Math.floor(Math.random() * WELCOME_MESSAGE_COUNT + 1);
    } while (newMessageId === welcomeMessageId);

    setTimeout(() => {
      setWelcomeMessageId(newMessageId);
      setIsRefreshing(false);
    }, 300); // 300ms 旋轉動畫
  };

  useEffect(() => {
    renderHeaderButton(true);
  }, [renderHeaderButton]);

  useEffect(() => {
    if (userDetails.userType === 'Adviser') {
      getNewReferralCount();
    }
    let localVersion = sessionStorage.getItem('version');
    if (userDetails.version) {
      setVersion(userDetails.version);
      sessionStorage.setItem('version', userDetails.version);
    } else if (localVersion) {
      setVersion(localVersion);
    }
  }, [userDetails, getNewReferralCount]);

  useEffect(() => {
    return () => endGuideline();
  }, [endGuideline]);

  useEffect(() => {
    let showTeamBlast = location.state && location.state.showTeamBlast ? location.state.showTeamBlast : false;
    setShowTeamBlast(showTeamBlast);
  }, [location]);

  useEffect(() => {
    let refresh = false;
    let state = { ...history.location.state };
    let search = history.location.search;

    if (history.location.search) {
      let searchParams = new URLSearchParams(location.search);
      let upgrade = searchParams.get(`upgrade`);
      if (upgrade === 'true') {
        searchParams.delete('upgrade');
        setSubscriptionDialogOpen(true);
        refresh = true;
      }
      search = searchParams.toString();
    }

    if (refresh) {
      history.replace({ ...history.location, state, search });
    }
  }, [history.location.state, history.location.search]);

  useEffect(() => {
    if (!isChubbUser) {
      return;
    }
    const dailyFeelingRedirect = sessionStorage.getItem('daily_feeling_redirect');
    if (dailyFeelingRedirect) {
      return;
    }
    const sourcesCheck = getSourcesCheck('daily_feeling');
    const feelingTagCheck = getFeelingTagCheck();
    if (sourcesCheck && !feelingTagCheck) {
      sessionStorage.setItem('daily_feeling_redirect', new Date().toISOString());
      history.push('/new/chubb-user-mission');
    }
  }, []);

  return (
    <AppContentContainer style={{ width: '100%', height: '100%', maxWidth: 'unset', marginLeft: 0, marginRight: 0 }}>
      <SubscriptionDialog
        intl={intl}
        userDetails={userDetails}
        stripePromise={stripePromise}
        open={subscriptionDialogOpen}
        onClose={() => setSubscriptionDialogOpen(false)}
        type="upgrade"
        currentSubscription={currentCoreSubscription}
        trialing={false}
        disableCoupon={true}
        defaultCoupon=""
      />
      <TravelKitLinkConstructor
        open={sosLinkDialogOpen}
        onClose={() => setSosLinkDialogOpen(false)}
        client={null}
        adviser={userDetails}
      />
      {!isLinkerUser && (
        <>
          <AdviserLoginLogic onCloseAllDialogs={onCloseAllDialogs} version={version} />

          {hasTeamBlast &&
            showTeamBlast &&
            teamBlastPop?.map(e => <TeamBlastPopUp markAsRead={markAsRead} teamBlastPop={e} />)}

          <TopNavigationPortal>
            <Box className="plus-btn-client dashboard-guideline-icon">
              <TopNavHelpButton ref={topNavHelpButtonRef} buttonProps={{ notClientStyle: true }} />
            </Box>
          </TopNavigationPortal>
        </>
      )}
      {isLinkerUser && (
        <Box
          style={{
            width: isSideNav ? 'min(100vw - 60px, 1180px)' : 'min(100vw, 1180px)',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Box style={{ padding: '0px 16px' }}>
            <LinkerAdviserHeader
              history={history}
              onUpgrade={openSubscriptionDialog}
              onCardLinkAlertClick={() => setLinkNfcCardDialogOpen(true)}
            />

            <LinkerNfcCardInstruction
              linkNfcCardDialogOpen={linkNfcCardDialogOpen}
              setLinkNfcCardDialogOpen={setLinkNfcCardDialogOpen}
            />
          </Box>
        </Box>
      )}
      {(isLinkerUser || version == 'pro') && (
        <Box
          style={{
            width: isSideNav ? 'min(100vw - 60px, 1180px)' : 'min(100vw, 1180px)',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Box className="home-page adviser">
            <Grid
              container
              spacing={isXsScreen ? 2 : 3}
              style={{ marginBottom: isXsScreen ? 160 : 20 }}
              sx={{ flexDirection: 'column', alignItems: 'flex-start' }}
            >
              {!isLinkerUser && (
                <Container maxWidth="sm" style={{ padding: '20px 0px 0px 0px' }}>
                  <Box className="home-page adviser">
                    {/* v9: swiper@6.3.5 + React 17 occasionally crashes on cold mount
                      with the loop+coverflow combo. Scope the failure here so the
                      rest of /home keeps rendering instead of looping the App
                      error boundary forever. */}
                    <ErrorBoundary label="swiper">
                      <Swiper
                        spaceBetween={15}
                        centeredSlides={true}
                        centeredSlidesBounds={true}
                        autoHeight={true}
                        initialSlide={0}
                        slidesPerView={isXsScreen ? 1.15 : 1.35}
                        loop={true}
                        loopedSlides={0}
                        navigation={false}
                        pagination={false}
                        effect="coverflow"
                        coverflowEffect={{
                          rotate: 0,
                          depth: 350,
                          modifier: 2,
                          stretch: 75,
                          slideShadows: false
                        }}
                        autoplay={{
                          delay: 3000
                        }}
                      >
                        <SwiperSlide>
                          <Card onClick={onClickBanner0}>
                            <img alt="travel-kit" src={ADVISER_HOME_PAGE_BANNERS[0][intl.locale]} />
                          </Card>
                        </SwiperSlide>

                        {!isLinkerUser && (
                          <SwiperSlide>
                            <Card onClick={onClickBanner1}>
                              <img alt="lazy-pack" src={ADVISER_HOME_PAGE_BANNERS[1][intl.locale]} />
                            </Card>
                          </SwiperSlide>
                        )}

                        <SwiperSlide>
                          <Card onClick={onClickBanner2}>
                            <img alt="classroom" src={ADVISER_HOME_PAGE_BANNERS[2][intl.locale]} />
                          </Card>
                        </SwiperSlide>
                      </Swiper>
                    </ErrorBoundary>
                  </Box>
                </Container>
              )}

              {!isXsScreen && !isLinkerUser && (
                <Typography color="textSecondary" style={{ fontSize: '150%', marginLeft: 10 }} component="div">
                  {intl.formatMessage({ id: 'home-greeting' })}
                  <Typography
                    color="primary"
                    style={{ fontSize: '100%' }}
                    sx={{
                      display: 'inline'
                    }}
                  >
                    {_.get(userDetails, 'name', '')}!
                  </Typography>
                </Typography>
              )}

              <Grid style={{ width: '100%' }}>
                {!isLinkerUser && (
                  <Grid
                    container
                    wrap="nowrap"
                    spacing={2}
                    sx={{
                      alignItems: 'center'
                    }}
                  >
                    <Grid size={{ xs: 11, sm: 7, md: 8 }}>
                      <DashboardSection />
                    </Grid>
                    <Grid size={{ xs: 1, sm: 5, md: 4 }} style={{ padding: 2 }}>
                      <ShortcutsSection
                        shouldDisableFunctions={isLinkerUser}
                        openSubscriptionDialog={openSubscriptionDialog}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid style={{ width: '100%' }}>
                <BusinessToolsSection disabled={isLinkerUser} actionReplacement={openSubscriptionDialog} />
              </Grid>

              <Grid style={{ width: '100%' }}>
                <MoreToolsSection
                  shouldDisableFunctions={isLinkerUser}
                  openSubscriptionDialog={openSubscriptionDialog}
                  getTopNavHelpButtonInstance={getTopNavHelpButtonInstance}
                />
              </Grid>

              {!isLinkerUser && (
                <Grid style={{ width: '100%', marginTop: 10 }}>
                  <VersionToggleButton version={version} setVersion={setVersion} />
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
      )}
      {!isLinkerUser && version === 'lite' && (
        <Box
          style={{
            display: 'flex',
            width: '100%',
            height: '100%',
            overflowX: 'hidden',
            overflowY: 'auto',
            background: 'linear-gradient(to bottom, #3A67F8 0%, white 70%)'
          }}
        >
          <ContactUsDialog
            open={contactUsDialogOpen}
            onClose={() => setContactUsDialogOpen(false)}
            feature="medical-reserve"
            image="img/medical-reserve-cover.png"
          />
          <Box style={{ margin: 'auto' }}>
            <Box style={{ display: 'flex', alignItems: 'center', marginLeft: 20, marginRight: 20, marginBottom: 26 }}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: intl.locale === 'en' ? 20 : 24,
                  maxWidth: 'min(600px, 100vw)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {intl.formatMessage({ id: 'new-dashboard-welcome-message-' + welcomeMessageId })}
                <IconButton
                  onClick={handleRefreshWelcomeMessage}
                  disabled={refreshClickCount >= 3}
                  style={{
                    color: refreshClickCount >= 3 ? 'rgba(255, 255, 255, 0.3)' : 'white',
                    transform: isRefreshing ? 'rotate(360deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease-in-out, color 0.2s ease',
                    padding: 4
                  }}
                  size="large"
                >
                  <RefreshIcon style={{ fontSize: 20 }} />
                </IconButton>
              </Typography>
            </Box>

            <Box style={{ display: 'flex', maxWidth: 'min(650px, 100vw)', marginBottom: isXsScreen ? 16 : 24 }}>
              <NewDashboardCardWithIconLarge
                title={intl.formatMessage({ id: 'linker-card' })}
                trackingEventName="Clicked on Lite Linker Card"
                img="img/linker_card_icon.svg"
                cardBackgroundColor="#FDF2FF"
                iconBackgroundColor="#F3B3FF"
                url="/profile-plus"
                style={{ marginLeft: 16, marginRight: isXsScreen ? 8 : 24 }}
              />

              <NewDashboardCardWithIconLarge
                title={intl.formatMessage({ id: 'sos-paper' })}
                trackingEventName="Clicked on Lite SOS Paper"
                img="img/sos_paper_icon.svg"
                cardBackgroundColor="#FFF9EE"
                iconBackgroundColor="#FFCD75"
                url="/add_demo_client"
                style={{ marginLeft: isXsScreen ? 8 : 24, marginRight: 16 }}
              />
            </Box>

            <Box style={{ display: 'flex', maxWidth: 'min(650px, 100vw)', marginBottom: isXsScreen ? 24 : 48 }}>
              <NewDashboardCardWithIconLarge
                title={intl.formatMessage({ id: 'lazy-pack-title-v2' })}
                trackingEventName="Clicked on Lite Lazy Pack"
                img="img/lazy_pack_icon.svg"
                cardBackgroundColor="#FCFFF2"
                iconBackgroundColor="#CCEB79"
                url="/hot_topic"
                style={{ marginLeft: 16, marginRight: isXsScreen ? 8 : 24 }}
              />

              <NewDashboardCardWithIconLarge
                title={intl.formatMessage({ id: 'finconcept' })}
                trackingEventName="Clicked on Lite Financial Concept"
                img="img/fin_concept_icon.svg"
                cardBackgroundColor="#F0F9FF"
                iconBackgroundColor="#86CEFE"
                onClick={openFinancialConcept}
                style={{ marginLeft: isXsScreen ? 8 : 24, marginRight: 16 }}
              />

              {/* <NewDashboardCardWithIconLarge
                title={intl.formatMessage({ id: 'ai-support' })}
                trackingEventName="Clicked on Lite AI Support"
                subtitle={intl.formatMessage({ id: 'beta-bracket' })}
                img="img/ai_support_icon.svg"
                cardBackgroundColor="#F0F9FF"
                iconBackgroundColor="#86CEFE"
                onClick={openChatBot}
                style={{ marginLeft: isXsScreen ? 8 : 24, marginRight: 16 }}
              /> */}
            </Box>

            <Box style={{ display: 'flex', maxWidth: 'min(650px, 100vw)', marginBottom: 16 }}>
              <NewDashboardCardWithIconSmall
                title={intl.formatMessage({ id: 'premium-financing' })}
                trackingEventName="Clicked on Lite Premium Financing"
                img="img/icons/calculator_active_color.svg"
                url="/premium_financing"
                style={{ marginLeft: 16, marginRight: isXsScreen ? 8 : 24 }}
              />
              <NewDashboardCardWithIconSmall
                title={intl.formatMessage({ id: 'medical-reserve' })}
                trackingEventName="Clicked on Lite Medical Reserve"
                img="img/icons/medical_reserve_active_color.svg"
                onClick={
                  showMedicalReserve ? () => trackDirect('viewMedicalReserve') : () => setContactUsDialogOpen(true)
                }
                url={showMedicalReserve ? '/new/medical-reserve' : ''}
                lock={!showMedicalReserve}
                style={{ marginLeft: isXsScreen ? 8 : 24, marginRight: 16 }}
              />
            </Box>

            <Box style={{ display: 'flex', maxWidth: 'min(650px, 100vw)', marginBottom: 16 }}>
              <NewDashboardCardWithIconSmall
                title={intl.formatMessage({ id: 'closing-skills' })}
                trackingEventName="Clicked on Lite Help Centre"
                img="img/icons/closing_class_active_color.svg"
                url={NativeOrWeb.isIOSPlatform() ? '/new_help_center_public' : '/new_help_center'}
                style={{ marginLeft: 16, marginRight: isXsScreen ? 8 : 24 }}
              />
              <NewDashboardCardWithIconSmall
                title={intl.formatMessage({ id: 'selected-newsfeed-nav-title' })}
                trackingEventName="Clicked on Lite Featured News"
                img="img/icons/selected_newsfeed_active_color.svg"
                onClick={() => {
                  // const isChubbUser = hasCampaignCode(userDetails, teamCampaignCodes, 'ENTCBB');
                  // if (isChubbUser) {
                  //   toast.info(IconToast('info', intl.formatMessage({ id: 'coming-soon' })), {
                  //     className: 'new-toast'
                  //   });
                  // } else {
                  history.push({ pathname: '/selected_newsfeed' });
                  // }
                }}
                style={{ marginLeft: isXsScreen ? 8 : 24, marginRight: 16 }}
              />
            </Box>

            <Box style={{ display: 'flex', maxWidth: 'min(650px, 100vw)', marginBottom: isXsScreen ? 24 : 44 }}>
              <NewDashboardCardWithIconSmall
                title={intl.formatMessage({ id: 'lite-ai-coach-title' })}
                trackingEventName="Clicked on Lite AiCoach"
                img="img/icons/ai_coach_active_color.svg"
                url={showAiCoach ? '/new/media-analysis' : ''}
                lock={!showAiCoach}
                style={{ marginLeft: 16, marginRight: isXsScreen ? 8 : 24 }}
              />
              {isChubbUser ? (
                <NewDashboardCardWithIconSmall
                  title={intl.formatMessage({ id: 'lite-user-mission-title' })}
                  trackingEventName="Clicked on Lite User Mission"
                  img="img/icons/mission_center_active_color.svg"
                  url="/new/chubb-user-mission"
                  style={{ marginLeft: isXsScreen ? 8 : 24, marginRight: 16 }}
                />
              ) : (
                <NewDashboardCardWithIconSmall
                  title={intl.formatMessage({ id: 'door-opener-travel-kit-title' })}
                  trackingEventName="Clicked on Lite Travel Kit"
                  img="img/icons/travel_kit_pin_active_color.svg"
                  onClick={() => openTravelKit('Lite Homepage')}
                  style={{ marginLeft: isXsScreen ? 8 : 24, marginRight: 16 }}
                />
              )}
            </Box>

            <VersionToggleButton version={version} setVersion={setVersion} />
          </Box>
        </Box>
      )}
      {showChatGPT && <ChatGPTFab />}
      <SupportFab
        openSupportBottomSheet={() => setSupportBottomSheetOpen(true)}
        openSupportDialog={() => setSupportDialogOpen(true)}
      />
      <SupportDialog open={supportDialogOpen} onClose={() => setSupportDialogOpen(false)} openChatBot={openChatBot} />
      <SupportBottomSheet
        open={supportBottomSheetOpen}
        onClose={() => setSupportBottomSheetOpen(false)}
        openChatBot={openChatBot}
      />
      <ChatBotDialog promptIdentifier="general_chat_bot" mode="general" />
    </AppContentContainer>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails,
    newReferralCount: state.referral.newReferralCount,
    hasTeamBlast: state.notificationCenter.hasTeamBlast,
    teamBlastPop: state.notificationCenter.teamBlastPop,
    firstGuidelineRan: state.user.firstGuidelineRan,
    teamCampaignCodes: state.functions.campaignCodes,
    userSubscription: state.userSubscription.userSubscription
  }),
  {
    renderHeaderButton,
    runGuideline,
    getNewReferralCount,
    toggleControl,
    endGuideline,
    markNotificationAsRead,
    updateFirstGuidelineState,
    toggleDialog
  }
)(AdviserHomePage);

export default injectIntl(withRouter(container));
